export default __webpack_public_path__ + "static/media/impact.96c4c843.webp";